import { render, staticRenderFns } from "./TraceabilityCollectionDateModal.vue?vue&type=template&id=a877ec20&scoped=true"
import script from "./TraceabilityCollectionDateModal.vue?vue&type=script&lang=js"
export * from "./TraceabilityCollectionDateModal.vue?vue&type=script&lang=js"
import style0 from "./TraceabilityCollectionDateModal.vue?vue&type=style&index=0&id=a877ec20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a877ec20",
  null
  
)

export default component.exports